import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/** Return URL landing for Buy Crypto — forwards to the order tracker. */
export default function BuyReturn() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  useEffect(() => {
    const oid = params.get("order");
    navigate(oid ? `/buy?order=${encodeURIComponent(oid)}` : "/buy", { replace: true });
  }, [navigate, params]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="buy-return">
      <Loader2 className="w-6 h-6 text-primary animate-spin" />
    </div>
  );
}
